import React from 'react'

import { PaymentTypeDetails } from 'models/PaymentTypeDetails'

import { Celula } from 'components/DetailSummary'

interface PaymentTypeDetailsViewProps {
  paymentTypeDetails: PaymentTypeDetails
}

const PaymentTypeDetailsView: React.FC<PaymentTypeDetailsViewProps> = ({
  paymentTypeDetails
}) => {
  const getPaymentMethodLabel = (method: string) => {
    const labels: { [key: string]: string } = {
      pix: 'PIX',
      boleto: 'Boleto',
      boleto_pix: 'Boleto/PIX',
      credit_card: 'Cartão de Crédito',
      credit_card_installments: 'Cartão de Crédito',
      credit_card_recurring: 'Cartão de Crédito Recorrente'
    }
    return labels[method] || method
  }

  const getEnabledPaymentMethods = () => {
    const methods = [] as Array<{
      method: string
      label: string
      maxInstallments: number
      maxInstallmentsWithoutFee?: number
    }>

    // PIX
    if (paymentTypeDetails.pix?.enabled) {
      methods.push({
        method: 'pix',
        label: getPaymentMethodLabel('pix'),
        maxInstallments: paymentTypeDetails.pix.max_installments
      })
    }

    // Boleto
    if (paymentTypeDetails.boleto?.enabled) {
      methods.push({
        method: 'boleto',
        label: getPaymentMethodLabel('boleto'),
        maxInstallments: paymentTypeDetails.boleto.max_installments
      })
    }

    // Cartão de crédito (usar configuração geral para exibir)
    if (paymentTypeDetails.credit_card?.enabled) {
      methods.push({
        method: 'credit_card',
        label: getPaymentMethodLabel('credit_card'),
        maxInstallments: Number(
          paymentTypeDetails.credit_card.max_installments || 1
        ),
        maxInstallmentsWithoutFee: Number(
          paymentTypeDetails.credit_card.max_installments_without_fee || 0
        )
      })
    }

    return methods
  }

  const enabledMethods = getEnabledPaymentMethods()

  // Filtrar apenas métodos com parcelamento (max_installments > 1)
  const methodsWithInstallments = enabledMethods.filter(
    (method) => method.maxInstallments > 1
  )

  // Não mostrar a seção se não houver nenhum método com parcelamento
  if (methodsWithInstallments.length === 0) {
    return null
  }

  // Uma <Celula> por meio parcelado, para o parcelamento entrar na mesma grade
  // do resto do resumo. Era o último bloco em "label ...... valor" e destoava
  // dentro da caixa nova.
  return (
    <>
      {methodsWithInstallments.map((method, index) => (
        <Celula key={index} label={`Parcelamento · ${method.label}`}>
          {`Até ${method.maxInstallments}x${
            typeof method.maxInstallmentsWithoutFee === 'number'
              ? ` (${
                  method.maxInstallmentsWithoutFee >= 1
                    ? `${method.maxInstallmentsWithoutFee}x sem juros`
                    : 'Repassar juros'
                })`
              : ''
          }`}
        </Celula>
      ))}
    </>
  )
}

export default PaymentTypeDetailsView
